'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Util


// Actions


// Selectors


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _lodash = require('lodash');

var _milanoteReselect = require('../milanoteReselect/milanoteReselect');

var _boardActions = require('../../element/board/boardActions');

var _socketChannelSelector = require('./socketChannelSelector');

var _socketChannelSelector2 = _interopRequireDefault(_socketChannelSelector);

var _remoteUsersSelector = require('./remoteUsersSelector');

var _currentUserSelector = require('../../user/currentUserSelector');

var _boardSelector = require('../../element/board/boardSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EMPTY_ARRAY = [];

var shallowPotentiallyStaleElementsSelector = (0, _milanoteReselect.createShallowSelector)(_socketChannelSelector2.default, _remoteUsersSelector.getRemoteActiveCurrentlyViewedBoardIds, _currentUserSelector.isGuestSelector, function (_ref, viewedBoardIds, isGuest) {
    var channels = _ref.channels;
    return isGuest ? EMPTY_ARRAY :
    // Any board that is currently being viewed and we are not connected to the channel of could be stale
    (0, _lodash.difference)(viewedBoardIds, channels);
});

var retrievedStaleElementsSelector = (0, _milanoteReselect.createShallowSelector)(shallowPotentiallyStaleElementsSelector, _boardSelector.getFetchedBoardIds, _currentUserSelector.isGuestSelector, function (potentiallyStaleElements, retrievedBoardIds, isGuest) {
    return isGuest ? EMPTY_ARRAY :
    // The stale elements are any elements that have been retrieved and are being edited by remote users in
    // channels that the current user is not connected to.
    (0, _lodash.intersection)(potentiallyStaleElements, retrievedBoardIds);
});

var mapStateToProps = (0, _reselect.createSelector)(retrievedStaleElementsSelector, _currentUserSelector.isGuestSelector, function (staleBoards, isGuest) {
    return { staleBoards: staleBoards, isGuest: isGuest };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchMarkElementsAsStale: function dispatchMarkElementsAsStale(ids) {
            return dispatch((0, _boardActions.markBoardResourcesAsStale)({ ids: ids }));
        }
    };
};

/**
 * Figures out which elements are currently being viewed by remote users and not the current user and marks those
 * elements as stale by firing a ELEMENTS_STALE action.
 */
var StaleBoardManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(StaleBoardManager, _React$Component);

    function StaleBoardManager() {
        _classCallCheck(this, StaleBoardManager);

        return _possibleConstructorReturn(this, (StaleBoardManager.__proto__ || Object.getPrototypeOf(StaleBoardManager)).apply(this, arguments));
    }

    _createClass(StaleBoardManager, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                staleBoards = _props.staleBoards,
                dispatchMarkElementsAsStale = _props.dispatchMarkElementsAsStale,
                isGuest = _props.isGuest;

            if (isGuest) return;

            staleBoards.length && dispatchMarkElementsAsStale(staleBoards);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var staleBoards = nextProps.staleBoards,
                dispatchMarkElementsAsStale = nextProps.dispatchMarkElementsAsStale,
                isGuest = nextProps.isGuest;

            if (isGuest) return;

            if (this.props.staleBoards !== staleBoards && staleBoards.length) {
                dispatchMarkElementsAsStale(staleBoards);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.Children.only(this.props.children);
        }
    }]);

    return StaleBoardManager;
}(_react2.default.Component)) || _class);


StaleBoardManager.propTypes = {
    children: _propTypes2.default.element.isRequired,
    staleBoards: _propTypes2.default.array,
    dispatchMarkElementsAsStale: _propTypes2.default.func,
    isGuest: _propTypes2.default.bool
};

exports.default = StaleBoardManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/collaboration/StaleBoardManager.js
// module id = 2118
// module chunks = 0